import React, { useEffect, useState } from "react";

const SA3GridDetail = (props: any) => {
  return (
    <>
      <div
        style={{
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
        }}
      >
        <div
          style={{ width: "50%", display: "inline-block", fontSize: "larger" }}
        >
          <div>
            <label className="labelrailgrid">Team Members :</label>
            <span> {props?.data?.data?.memberName}</span>
          </div>
          {/* <div>
            <label className="labelrailgrid">Problem To Solve :</label>
            <span> {props?.data?.data?.problemToSolve}</span>
          </div> */}
          <div>
            <label className="labelrailgrid">Strategic Objective :</label>
            <span> {props?.data?.data?.strategicObjective}</span>
          </div>
          <div>
            <label className="labelrailgrid">Problem Statement :</label>
            <span> {props?.data?.data?.problemStatement} </span>
          </div>
          <div>
            <label className="labelrailgrid">Trigger :</label>
            <span> {props?.data?.data?.trigger} </span>
          </div>
          <div>
            <label className="labelrailgrid">Done :</label>
            <span> {props?.data?.data?.done} </span>
          </div>
          <div>
            <label className="labelrailgrid">In Scope :</label>
            <span> {props?.data?.data?.inScope} </span>
          </div>
          <div>
            <label className="labelrailgrid">Out Of Scope :</label>
            <span> {props?.data?.data?.outOfScope} </span>
          </div>
          <div>
            <label className="labelrailgrid">Is Rapid Experiment :</label>
            <span> {props?.data?.data?.rapidExperiment} </span>
          </div>
        </div>
        <div
          style={{ width: "50%", display: "inline-block", fontSize: "larger" }}
        >
          <div>
            <label className="labelrailgrid">Result Start Date :</label>
            <span>
              {" "}
              {props?.data?.data?.resultStartDate === null
                ? ""
                : new Date(
                    props?.data?.data?.resultStartDate
                  ).toLocaleDateString()}{" "}
            </span>
          </div>
          <div>
            <label className="labelrailgrid">Result End Date :</label>
            <span>
              {" "}
              {props?.data?.data?.resultEndDate === null
                ? ""
                : new Date(
                    props?.data?.data?.resultEndDate
                  ).toLocaleDateString()}{" "}
            </span>
          </div>
          {/* <div>
            <label className="labelrailgrid">Result Time Period :</label>
            <span> {props?.data?.data?.resultTimePeriod} </span>
          </div> */}
          <div>
            <label className="labelrailgrid">Result Frequency :</label>
            <span> {props?.data?.data?.resultFrequency} </span>
          </div>
          <div>
            <label className="labelrailgrid">What Went Well :</label>
            <span> {props?.data?.data?.whatWentWell} </span>
          </div>
          <div>
            <label className="labelrailgrid">What Not Went Well :</label>
            <span> {props?.data?.data?.whatNotWentWell} </span>
          </div>
          <div>
            <label className="labelrailgrid">What Helped :</label>
            <span> {props?.data?.data?.whatHelped} </span>
          </div>
          <div>
            <label className="labelrailgrid">What Hindered :</label>
            <span> {props?.data?.data?.whatHindered} </span>
          </div>
          <div>
            <label className="labelrailgrid">Lesson Learnt :</label>
            <span> {props?.data?.data?.lessonLearnt} </span>
          </div>
        </div>
      </div>
      <div
        style={{
          border: "1px solid grey",
          borderRadius: "5px",
          padding: "5px",
          marginTop: "5px",
        }}
      >
        <div
          style={{ width: "20%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">Status:</span>
          <span>{props?.data?.data?.status}</span>
        </div>
        <div
          style={{ width: "25%", display: "inline-block", fontSize: "larger" }}
        >
          <span className="labelrailgrid">Created Date:</span>
          <span>
            {" "}
            {new Date(props?.data?.data?.createdOn).toLocaleDateString()}
          </span>
        </div>
      </div>
    </>
  );
  //   </ScrollView>
};
export default SA3GridDetail;
